<template>
  <div id="userInfo">
    <ul class="from">
      <li class="fromItem">
        <div class="key">姓名：</div>
        <div class="value">
          <span>{{ subData.userInfo.realname }}</span>
          <span>{{ subData.userInfo.idCard }}</span>
          <div v-if="subData.userInfo.realname" style="display: inline-block">已完成实名认证，无法修改</div>
        </div>
      </li>
      <li class="fromItem">
        <div class="key">学者图片：</div>
        <div class="value" >
          <img
            v-if="subData.userInfo.headPhoto"
            class="img"
            :src="`${$global.imgUrl}${subData.userInfo.headPhoto}`"
            alt
          />
          <img
            v-else
            class="img"
            :src="require('@/assets/img/qietu/default.png')"
            alt
          />
          <Upload
            class="upload"
            :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
            :headers="{ token: token }"
            accept=".png,.jpg,.jpeg"
            :max-size="1024"
            :show-upload-list="false"
            :on-exceeded-size="handleMaxSize"
            :on-success="handleSuccess"
          >
            <img src="@/assets/img/userInfo/bi.png" v-if="edit" alt />
          </Upload>
        </div>
      </li>
      <li class="fromItem">
        <div class="key">性别：</div>
        <div class="value">
          <span>{{ subData.userInfo.sex }}</span>
          <img
            @click="
              changeDetails({
                name: '性别',
                type: 'sel',
                value: subData.userInfo.sex,
                key: 'sex',
              })
            "
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">民族：</div>
        <div class="value">
          <span>{{ subData.userInfo.nation }}</span>
          <img
            @click="
              changeDetails({
                name: '民族',
                type: 'input',
                value: subData.userInfo.nation,
                key: 'nation',
              })
            "
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">出生年月：</div>
        <div class="value">
          <span>{{ subData.userInfo.birthday | dayFormate }}</span>
          <img
            @click="
              changeDetails({
                name: '出生年月',
                type: 'sel',
                value: subData.userInfo.birthday,
                key: 'birthday',
              })
            "
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">籍贯：</div>
        <div class="value">
          <span>{{ subData.userInfo.nationPlace }}</span>
          <img
            @click="
              changeDetails({
                name: '籍贯',
                type: 'input',
                value: subData.userInfo.nationPlace,
                key: 'nationPlace',
              })
            "
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">最高学历：</div>
        <div class="value">
          <span>{{ subData.userInfo.education }}</span>
          <img
            @click="
              changeDetails({
                name: '学历',
                type: 'input',
                value: subData.userInfo.education,
                key: 'education',
              })
            "
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">毕业院校：</div>
        <div class="value">
          <span>{{ subData.userInfo.school }}</span>
          <img
            @click="
              changeDetails({
                name: '毕业院校',
                type: 'input',
                value: subData.userInfo.school,
                key: 'school',
              })
            "
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">现单位/院校：</div>
        <div class="value">
          <span>{{ subData.userInfo.unit }}</span>
          <img
            @click="
              changeDetails({
                name: '现单位/院校',
                type: 'input',
                value: subData.userInfo.unit,
                key: 'unit',
              })
            "
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">现任职位：</div>
        <div class="value">
          <span>{{ subData.userInfo.job }}</span>
          <img
            @click="
              changeDetails({
                name: '现任职位',
                type: 'input',
                value: subData.userInfo.job,
                key: 'job',
              })
            "
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">现单位/院校地址：</div>
        <div class="value">
          <span>{{ subData.userInfo.unitAddr }}</span>
          <img
            @click="
              changeDetails({
                name: '现单位\/院校地址',
                type: 'input',
                value: subData.userInfo.unitAddr,
                key: 'unitAddr',
              })
            "
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">原单位/院校：</div>
        <div class="value">
          <div style="display: flex; align-items: center; flex-wrap: wrap">
            <div
              style="margin-right: 30px; margin-bottom: 10px"
              v-show="subData.originalUnits.length !== 0"
              v-for="(item, index) in subData.originalUnits"
              :key="index"
            >
              <span style="margin-right: 10px">{{ item.unitName }}</span>
              <img
                @click="delUnit(index)"
                src="@/assets/img/userInfo/2222.png"
                v-if="edit"
                alt
              />
            </div>
            <img
              @click="
                changeDetails({
                  name: '原单位\/院校',
                  type: 'input',
                  value: '',
                  key: 'Historyjob',
                })
              "
              style="margin-bottom: 10px"
              src="@/assets/img/userInfo/bi.png"
              v-if="edit"
              alt
            />
          </div>
        </div>
      </li>
      <li class="fromItem">
        <div class="key">职称：</div>
        <div class="value">
          <span v-for="item in subData.titles" :key="item.id">{{
            item.levelTwo
          }}（{{item.levelOneName}}）</span>
          <img
            @click="setLevel"
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">学科领域：</div>
        <div class="value">
          <span v-for="item in subData.subjects" :key="item.id">
            {{ item.levelOneName }} / {{ item.levelTwoName }}
          </span>
          <img
            @click="setsubJect"
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">研究方向：</div>
        <div class="value">
          <span>{{ subData.userInfo.researchDirection }}</span>
          <img
            @click="
              changeDetails({
                name: '研究方向',
                type: 'input',
                value: subData.userInfo.researchDirection,
                key: 'researchDirection',
              })
            "
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
      <li class="fromItem">
        <div class="key">个人简介：</div>
        <div class="value">
          <span>{{ subData.userInfo.profile }}</span>
          <img
            @click="
              changeDetails({
                name: '个人简介',
                type: 'input',
                value: subData.userInfo.profile,
                key: 'profile',
              })
            "
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
    </ul>

    <div class="btn">
      <div v-if="!edit" @click="setEdit" :class="isEdit ? 'affirm' : 'close'">
        {{ isEdit ? "编辑" : "审核中" }}
      </div>
      <div v-if="edit" @click="back" class="close">取消</div>
      <Button v-if="edit" v-throttleClick @click="sub" class="affirm"
        >提交</Button
      >
    </div>
    <Modal
      :scrollable="true"
      v-model="alert"
      width="572px"
      class-name="vertical-center-modal"
      :footer-hide="true"
    >
      <div class="alert">
        <div class="title">{{ changeObj.name }}</div>
        <div class="content">
          <template v-if="changeObj.key === 'sex'">
            <Select
              v-model="changeObj.value"
              style="width: 462px; margin-left: 57px; margin-top: 20px"
            >
              <Option value="男">男</Option>
              <Option value="女">女</Option>
            </Select>
          </template>
          <template v-else-if="changeObj.key === 'education'">
            <Select
              v-model="changeObj.value"
              style="width: 462px; margin-left: 57px; margin-top: 20px"
            >
              <Option value="博士研究生">博士研究生</Option>
              <Option value="硕士研究生">硕士研究生</Option>
              <Option value="本科">本科</Option>
              <Option value="专科">专科</Option>
              <Option value="其他">其他</Option>
            </Select>
          </template>
          <template v-else-if="changeObj.key === 'profile'">
            <Input
              v-model="changeObj.value"
              :autosize="{ minRows: 4, maxRows: 8 }"
              maxlength="1000"
              show-word-limit
              type="textarea"
              style="width: 462px; margin-left: 57px; margin-top: 20px"
              :placeholder="`请输入${changeObj.name}`"
            />
          </template>
          <template v-else-if="changeObj.key === 'birthday'">
            <DatePicker
              format="yyyy-MM-dd"
              type="date"
              @on-change="handleChange"
              :value="changeObj.value"
              style="width: 462px; margin-left: 57px; margin-top: 20px"
            ></DatePicker>

            <!--            <Input-->
            <!--              v-model="changeObj.value"-->
            <!--              style="width: 462px; margin-left: 57px; margin-top: 20px"-->
            <!--              placeholder="请输入民族"-->
            <!--            />-->
          </template>
          <template v-else-if="changeObj.key === 'titles'">
            <div
              class="title-list"
              v-for="(item, index) in changeObj.value"
              :key="index"
            >
              <Select
                style="width: 150px; margin-right: 10px"
                placeholder="请选择职称级别"
                v-model="item.levelOne"
                label-in-value
                @on-change="($event) => titlesSelectChange(index,$event)"
              >
                <Option
                  v-for="obj in titleOptions"
                  :key="obj.titleCode"
                  :value="obj.titleCode"
                  >{{ obj.titleName }}</Option
                >
              </Select>
              <Input
                style="width: 250px; margin-right: 10px"
                placeholder="请输入职称"
                v-model="item.levelTwo"
              />
              <Icon
                style="cursor: pointer; vertical-align: middle"
                :type="
                  index < changeObj.value.length - 1 || index === 4
                    ? 'md-remove-circle'
                    : 'md-add-circle'
                "
                size="26"
                color="#999999"
                @click="addTitles(item, index)"
              />
            </div>
          </template>
          <template v-else-if="changeObj.key === 'setsubJect'">
            <div
              class="title-list"
              v-for="(item, index) in changeObj.value"
              :key="index"
            >
              <Cascader
                style="display: inline-block; width: 300px; margin-right: 10px"
                placeholder="请输入学科领域"
                filterable
                trigger="hover"
                v-model="changeObj.value[index]"
                :data="subjectsOptions"
              ></Cascader>
              <Icon
                style="cursor: pointer; vertical-align: middle"
                :type="
                  index < changeObj.value.length - 1 || index === 4
                    ? 'md-remove-circle'
                    : 'md-add-circle'
                "
                size="26"
                color="#999999"
                @click="addSubjects(item, index)"
              />
            </div>
          </template>
          <template v-else>
            <Input
              v-model="changeObj.value"
              style="width: 462px; margin-left: 57px; margin-top: 20px"
              :placeholder="`请输入${changeObj.name}`"
            />
          </template>
        </div>
        <div class="btn">
          <div @click="closeAlert" class="close">取消</div>
          <Button v-throttleClick @click="affirm" class="affirm">确认</Button>
        </div>
      </div>
    </Modal>
    <Spin v-if="spinShow" fix>
      <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "userInfo",
  computed: {
    ...mapState(["token"]),
  },
  filters: {
    reviewStatusFilter: function (num) {
      if (num === 0) return `审核中`;
      if (num === 1) return `编辑`;
    },
  },
  data() {
    return {
      alert: false,
      edit: false,
      spinShow: false,
      changeObj: {
        key: "",
        type: "",
        name: "",
        value: "",
      },
      subData: {
        originalUnits: [],
        subjects: [],
        titles: [],
        userInfo: {},
      },
      isEdit: false,
      titleOptions: [],
      subjectsOptions: [],
    };
  },
  async created() {
    this.getSubData();
    const res1 = await this.$apis.userServe.getRelationList();
    this.subjectsOptions = [...res1.data];
    const res2 = await this.$apis.userServe.getTitleList();
    this.titleOptions = [...res2.data];
  },
  methods: {
    // 删除原单位院校
    delUnit(index) {
      this.subData.originalUnits.splice(index, 1);
    },
    // 退出编辑
    back() {
      this.edit = false;
      this.getSubData();
    },
    // 校验
    check() {
      if (
        !this.subData.userInfo.hasOwnProperty("headPhoto") ||
        this.subData.userInfo.headPhoto === ""
      ) {
        this.$Message.error("请上传头像");
        return false;
      } else if (
        !this.subData.userInfo.hasOwnProperty("education") ||
        this.subData.userInfo.education === ""
      ) {
        this.$Message.error("请选择最高学历");
        return false;
      } else if (
        !this.subData.userInfo.hasOwnProperty("school") ||
        this.subData.userInfo.school === ""
      ) {
        this.$Message.error("请填写毕业院校");
        return false;
      } else if (
        !this.subData.userInfo.hasOwnProperty("unit") ||
        this.subData.userInfo.unit === ""
      ) {
        this.$Message.error("请填写现单位/院校");
        return false;
      } else if (
        !this.subData.userInfo.hasOwnProperty("researchDirection") ||
        this.subData.userInfo.researchDirection === ""
      ) {
        this.$Message.error("请填写研究方向");
        return false;
      } else if (this.subData.subjects.length === 0) {
        this.$Message.error("请填写学科领域");
        return false;
      } else if (this.subData.titles.length === 0) {
        this.$Message.error("请填写职称");
        return false;
      } else {
        return true;
      }
    },
    // 提交编辑
    sub() {
      if (this.check()) {
        this.$apis.userServe.setUserInfo(this.subData).then(({ data }) => {
          if (data.resultCode == "200") {
            this.back(data);
          } else {
            this.$Message.error(data.content.msg);
          }
        });
      }
    },
    // 日期选择
    handleChange(e) {
      this.changeObj.value = e;
    },

    // 学科领域多项添加或者删除
    addSubjects(item, index) {
      if (index < this.changeObj.value.length - 1 || index === 4) {
        this.changeObj.value.splice(index, 1);
      } else {
        if (item[0] && item[1]) {
          this.changeObj.value.push([]);
        }
      }
    },
    // 打开学科领域弹窗
    setsubJect() {
      this.changeObj = {
        key: "setsubJect",
        name: "学科领域",
        value:
          this.subData.subjects.length > 0
            ? this.subData.subjects.map((item) => [
                item.levelOne,
                item.levelTwo,
              ])
            : [{}],
      };
      this.alert = true;
    },
    // 职称选择
    titlesSelectChange(index, query) {
      this.changeObj.value[index].levelOneName = query.label
    },
    // 职称多项添加或者删除
    addTitles(item, index) {
      if (index < this.changeObj.value.length - 1 || index === 4) {
        this.changeObj.value.splice(index, 1);
      } else {
        if (item.levelOne && item.levelTwo) {
          this.changeObj.value.push({
            levelOne: "",
            levelTwo: "",
          });
        }
      }
    },
    // 打开职称修改窗口
    setLevel() {
      this.changeObj = {
        key: "titles",
        name: "职称",
        value:
          this.subData.titles.length > 0
            ? this.$global.deepClone(this.subData.titles)
            : [{}],
      };
      this.alert = true;
    },
    // 打开编辑框
    changeDetails(obj) {
      this.changeObj = obj;
      this.alert = true;
    },
    //图片过大
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片上传过大",
        desc: file.name + "该文件大小超过1M.",
      });
    },
    // 上传图片成功
    handleSuccess(res) {
      this.subData.userInfo.headPhoto = res.content.url;
    },
    // 开始编辑
    setEdit() {
      if (!this.isEdit) return;
      this.edit = true;
    },
    // 取消关闭编辑窗口
    closeAlert() {
      (this.changeObj = {
        key: "",
        type: "",
        name: "",
        value: "",
      }),
        (this.alert = false);
    },
    // 编辑窗中点击确定
    affirm() {
      if (this.changeObj.key === "Historyjob") {
        if (this.changeObj.value)
          this.subData.originalUnits.push({ unitName: this.changeObj.value });
      } else if (this.changeObj.key === "titles") {
        this.subData.titles = this.changeObj.value.filter((item) => {
          return item.levelOne !== "" && item.levelTwo !== "";
        });
      } else if (this.changeObj.key === "setsubJect") {
        let arr = [];
        this.changeObj.value.forEach((item) => {
          if (item[0] && item[1]) {
            let One = "";
            let Two = "";
            this.subjectsOptions.forEach((fItem) => {
              if (fItem.value === item[0]) {
                One = fItem.label;
                fItem.children.forEach((CItem) => {
                  if (CItem.value === item[1]) {
                    Two = CItem.label;
                  }
                });
              }
            });
            arr.push({
              levelOne: item[0],
              levelOneName: One,
              levelTwo: item[1],
              levelTwoName: Two,
            });
          }
        });
        this.subData.subjects = arr;
      } else {
        this.subData.userInfo[this.changeObj.key] = this.changeObj.value;
      }
      this.alert = false;
    },
    // 获取信息
    async getSubData() {
      this.spinShow = true;
      let res = await this.$apis.userServe.userEditType();
      this.subData.originalUnits = [...res.content.baseInfo.originalUnits];
      this.subData.subjects = [...res.content.baseInfo.subjects];
      this.subData.titles = [...res.content.baseInfo.titles];
      this.subData.userInfo = res.content.baseInfo.userInfo;
      this.isEdit = res.content.editable;
      this.spinShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-spin-col .circular {
  width: 25px;
  height: 25px;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.alert {
  .subject::-webkit-scrollbar {
    width: 4px;
  }

  .subject::-webkit-scrollbar-thumb {
    width: 4px;
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .subject::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .subject {
    height: 200px;
    overflow-y: scroll;
  }

  .btn {
    margin-top: 34px;
    width: 100%;
    height: 120px;
    //background: pink;
    display: flex;
    align-items: center;
    justify-content: center;

    .close {
      text-align: center;
      line-height: 38px;
      width: 72px;
      height: 38px;
      background: #ffffff;
      border: 1px solid #d2d2d2;
      border-radius: 8px;
      margin-right: 13px;
      cursor: pointer;
    }

    .affirm {
      margin-left: 13px;
      width: 70px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      color: #fff;
      background: #007fff;
      border-radius: 8px;
      cursor: pointer;
      border: none;
    }
  }

  .addList {
    margin-left: 57px;
    margin-top: 20px;

    width: 80%;
    display: flex;
    flex-wrap: wrap;

    div {
      margin-right: 10px;
      cursor: pointer;
      .closeIcon {
        // display: block;
        width: 3px;
        height: 3px;
        font-size: 3px;
        cursor: pointer;
        img {
          width: 10px;
          height: 10px;
        }
      }
    }
  }

  .leaveOne {
    margin-left: 57px;
    margin-top: 20px;

    width: 80%;
    display: flex;
    flex-wrap: wrap;

    .oneItem {
      //text-align: center;
      cursor: pointer;
      height: 50px;
      //background: pink;
      width: 25%;
    }

    .threeItem {
      margin-top: 20px;
      width: 100%;

      .name {
        cursor: pointer;
        //width: 54px;
        display: flex;
        .leaveBox {
          display: flex;
          flex-wrap: wrap;
          flex: 1;
          span {
            margin-right: 5px;
            margin-bottom: 3px;
          }
        }
      }
    }

    .twoItem {
      margin-top: 20px;
      width: 25%;

      .name {
        cursor: pointer;
        //background: pink;
        //cursor: pointer;
        //width: 54px;
        display: inline-block;
      }
    }
  }

  .title {
    margin-left: 57px;
    margin-top: 50px;
    height: 25px;
    font-size: 24px;
    //background: yellow;
    font-family: Microsoft YaHei;
    font-weight: 900;
    color: #333333;
    line-height: 24px;
  }
  .title-list {
    margin-left: 57px;
    margin-top: 20px;
  }
}

#userInfo {
  position: relative;
  margin-top: 15px;
  width: 1200px;
  min-height: 790px;
  padding-top: 50px;
  background: #ffffff;
  padding-bottom: 20px;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);

  .upload {
    display: inline-block;
  }

  .btn {
    width: 1200px;
    display: flex;
    justify-content: center;
    align-items: center;

    height: 50px;
    //background: pink;
    .close {
      text-align: center;
      line-height: 38px;
      width: 72px;
      height: 38px;
      background: #ffffff;
      border: 1px solid #d2d2d2;
      border-radius: 8px;
      margin-right: 13px;
      cursor: pointer;
    }

    .affirm {
      margin-left: 13px;
      text-align: center;
      line-height: 38px;
      width: 70px;
      height: 36px;
      color: #fff;
      background: #007fff;
      border-radius: 8px;
      cursor: pointer;
    }
  }

  .from {
    margin: 0 50px 30px 70px;

    .fromItem {
      display: flex;
      min-height: 50px;
      margin-bottom: 10px;

      .key {
        width: 120px;
      }

      .value {
        flex: 1;
        span {
          margin-right: 20px;
        }

        img {
          cursor: pointer;
          width: 13px;
          height: 13px;
        }

        div {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }

        .img {
          width: 84px;
          height: 84px;
          border-radius: 50%;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
